export default __webpack_public_path__ + "maps-overview-annotation-view-1200-a87d78ec28fc2f96c246d7221065fa8f.png";